import React, { useCallback, useMemo, } from 'react';
import { ADD_ROW, DELETE_ROW, JSON_KEY_TIME, JSON_KEY_USER, TABLE_HEADER_TIME, 
   // TABLE_HEADER_ID, JSON_KEY_ID, 
   UPDATE_ROW, TABLE_HEADER_NOTIFICATIONS, JSON_KEY_NOTIFICATION, TABLE_HEADER_SERVERITY, 
   JSON_KEY_SERVERITY, NOTIFICATION_INFORMATION, NOTIFICATION_NAME_INFORMATION, NOTIFICATION_WARNING,
   NOTIFICATION_NAME_WARNING, NOTIFICATION_UNKNOWN, NOTIFICATION_ERROR, NOTIFICATION_NAME_ERROR, NOTIFICATION_FATAL,
   NOTIFICATION_NAME_FATAL, NOTIFICATION_NAME_UNKNOWN,
   TABLE_HEADER_FROM,
   NOTIFICATION_NAME_ADMIN,
   NOTIFICATION_ADMIN,
   NOTIFICATION_NAME_CRITICAL,
   NOTIFICATION_CRITICAL,
   ServerityColor} 
from '../../common/common';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const Notifications2 = () => {
   function ConvertServerity(serverity) {
      switch (serverity) {
         case NOTIFICATION_INFORMATION:
            return NOTIFICATION_NAME_INFORMATION;
         case NOTIFICATION_WARNING:
            return NOTIFICATION_NAME_WARNING
         case NOTIFICATION_UNKNOWN:
            return NOTIFICATION_NAME_WARNING;
         case NOTIFICATION_ERROR:
            return NOTIFICATION_NAME_ERROR;
         case NOTIFICATION_FATAL:
            return NOTIFICATION_NAME_FATAL;
         case NOTIFICATION_CRITICAL:
            return NOTIFICATION_NAME_CRITICAL;
         case NOTIFICATION_ADMIN:
            return NOTIFICATION_NAME_ADMIN;
         default:
            return NOTIFICATION_NAME_UNKNOWN
      }
   }

   // const columnStyling = useMemo(() => {
   //    return Object.fromEntries(
   //       ['ser'].map((field) => [
   //          field,
   //          (rowData) => ({
   //             color: ServerityColor(rowData[field]),
   //          }),
   //       ])
   //    );
   // }, []); 
   
   const columnStyling = useMemo(() => {
      return Object.fromEntries(
         ['ser'].map((field) => [
            field,
            (rowData) => {
            const isCritical = rowData[field] === NOTIFICATION_NAME_CRITICAL;

            return {
               color: ServerityColor(rowData[field]),
               className: isCritical ? 'vt-critical-flash' : ''
            };
            },
         ])
      );
   }, []);

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[NotificationsTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[NotificationsTable] Row Double Clicked:`, rowData);
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('notifications details: ', details.data);
    
      // Modified row creation (common for both ADD_ROW and UPDATE_ROW)
      const modifiedRow = {
         ...details.data,
         ser: ConvertServerity(details.data.ser),
      };

      // Switch case to handle different events
      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  console.log(`Duplicate notification with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });            break;

         case UPDATE_ROW:
            setLocalTableData(prev => prev.map(row => row.id === modifiedRow.id ? modifiedRow : row));
            break;

         case DELETE_ROW:
            setLocalTableData(prev => prev.filter(row => row.code !== details.data.code));
            break;

         default:
            break;
      }
   }, []);

   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // don't show it but it is still there
      { Header: TABLE_HEADER_TIME, accessor: JSON_KEY_TIME },
      { Header: TABLE_HEADER_NOTIFICATIONS, accessor: JSON_KEY_NOTIFICATION },
      { Header: TABLE_HEADER_SERVERITY, accessor: JSON_KEY_SERVERITY },
      { Header: TABLE_HEADER_FROM, accessor: JSON_KEY_USER },
   ], []);

   return (
      <VirtualizedTablesTemplate
         columns={columns}
         eventHandlers={handleEvents}
         tableName="NotificationsTable"
         onRowClick={handleSingleClick}
         onRowDoubleClick={handleDoubleClick}
         highlightOnClick={true}
         enableSearch={true}
         columnStyling={columnStyling}
      />
   );
};

export default Notifications2;
